<template>
  <div>
    <!-- <nav-head></nav-head> -->
    <h2 v-if="data !== null && data.length === 0" style="padding: 2rem">
      没有训练记录
    </h2>
    <div class="instanceCellFather">
      <div v-for="(d, i) in data" :key="i" class="instanceCell">
        <!-- 实例名称行 -->
        <span v-if="!d.rename">
          <span v-if="d.name" class="instanceName">{{ d.name }}</span>
          <span v-if="!d.name" class="noNameInstance">（未命名实例）</span>
          <span class="noNameInstance">(iid:{{ d.id }})</span>
          <a-button
            @click="showChangeName(i, d)"
            class="smallButton"
            type="link"
            >修改实例名</a-button
          >
        </span>
        <a-row v-if="d.rename" type="flex" align="middle">
          <a-col :span="5">
            <a-input v-model="d.name"></a-input>
          </a-col>
          <a-col>
            <a-button
              @click="changeName(i, d)"
              class="smallButton"
              type="primary"
              >确认</a-button
            >
          </a-col>
        </a-row>
        <!-- 输入输出行 -->
        <p><b>输入：</b>{{ d.input_field_list.join("、") }}</p>
        <p><b>输出：</b>{{ d.output_field_list.join("、") }}</p>
        <p><b>训练参数：</b>{{ d.train_params }}</p>
        <!-- 时间行 -->
        <p>
          <span style="margin-right: 2rem">
            <b>开始时间：</b>{{ d.add_time.replace("T", "，") }}
          </span>
          <span>
            <span v-if="d.finish_time">
              <b>结束时间：</b>
              <span>
                {{ d.finish_time.replace("T", "，") }}
              </span>
            </span>
            <span v-if="!d.finish_time">
              <a-icon type="sync" spin />训练进行中
            </span>
          </span>
        </p>
        <!-- 算法行 -->
        <a-row>
          <algorithm-button
            :aId="d.algorithm.id"
            :aName="d.algorithm.name"
          ></algorithm-button>
        </a-row>

        <!-- 操作按钮 -->
        <a-row type="flex" justify="end">
          <a-col v-if="d.finish_time">
            <a-button
              @click="changeDetail(i, d)"
              shape="round"
              class="marginRightSmall"
            >
              {{ d.detail ? "折叠" : "详情" }}
            </a-button>
            <a-button
              shape="round"
              class="marginRightSmall"
              type="primary"
              @click="calc(d.id)"
            >
              计算
            </a-button>
            <a-popconfirm
              title="实例将可以被其他人调用，是否确认公开？"
              ok-text="是"
              cancel-text="否"
              @confirm="publicInstance(i, d)"
            >
              <a-button shape="round" class="marginRightSmall" type="primary">
                {{ d.is_published ? "取消公开" : "公开" }}
              </a-button>
            </a-popconfirm>
            <a-popconfirm
              title="确认删除该实例？"
              ok-text="是"
              cancel-text="否"
              @confirm="deleteInstance(i, d)"
            >
              <a-button shape="round" class="marginRightSmall" type="danger">
                删除
              </a-button>
            </a-popconfirm>
          </a-col>

          <a-col v-if="!d.finish_time">
            <a-button @click="refreshFinish(i, d)">刷新</a-button>
          </a-col>
        </a-row>
        <!-- 详情 -->
        <my-result
          v-if="d.detail"
          :result="d.result"
          :showAlert="false"
          class="instanceDetail"
        ></my-result>
      </div>
      <!-- 页码 -->
      <a-pagination
        :total="totalInstances"
        :defaultPageSize="30"
        v-model="currentPage"
        @change="changePage"
      />
    </div>
  </div>
</template>

<script>
import myResult from './result'
import algorithmButton from './algorithmButton'
export default {
  components: { myResult, algorithmButton },
  data() {
    return {
      data: null,
      currentPage: 1,
      totalInstances: 0
    }
  },
  methods: {
    showChangeName(i, d) {
      d.rename = true
      this.$set(this.data, i, d)
    },
    async changeName(i, d) {
      this.$set(this.data, i, d)
      const name = d.name ? d.name : ''
      const resp = await this.$http.put(
        `/instance/${d.id}/set_name?name=${name}`
      )
      if (resp.status === 200) {
        this.$set(this.data, i, d)
        d.rename = false
      }
    },
    async changeDetail(i, d) {
      d.detail = !d.detail
      if (d.detail & !d.result) {
        const resp = await this.$http.get(`/instance/${d.id}/result`)
        if (resp.status === 200) {
          d.detail = true
          d.result = resp.data
        }
      }
      this.$set(this.data, i, d)
    },
    async deleteInstance(i, d) {
      this.data.splice(i, 1)
      await this.$http.delete(`/instance/${d.id}/delete`)
    },
    async publicInstance(i, d) {
      // 要公开的实例要有名字
      if ((d.is_published === false) & !d.name) {
        this.$message.error('请先对实例命名')
        return ''
      }
      const urlEnd = d.is_published ? 'unpublish' : 'publish'
      const resp = await this.$http.put(`/share/${d.id}/${urlEnd}`)
      if (resp.status === 200) {
        d.is_published = !d.is_published
        this.$set(this.data, i, d)
      }
    },
    trainNew(aid) {
      this.$router.push('/train/' + aid)
    },
    async refreshFinish(i, d) {
      const resp = await this.$http(`/instance/${d.id}/train_status`)
      if (resp.data.finish_time) {
        d.finish_time = resp.data.finish_time
        this.$set(this.data, i, d)
        this.$message.success('实例训练完成')
      } else {
        this.$message.info('实例训练中')
      }
    },
    calc(iid) {
      this.$router.push('/calc/' + iid)
    },
    async loadInstance() {
      const resp = await this.$http.get(
        '/my_instances?page=' + this.currentPage
      )
      this.data = resp.data.instances
      this.totalInstances = this.data.length
      for (const d of this.data) {
        d.rename = false
        d.detail = false
        d.result = null
        d.input_field_list = []
        for (const i of d.input_field) {
          d.input_field_list.push(i.name)
        }
        d.output_field_list = []
        for (const i of d.output_field) {
          d.output_field_list.push(i.name)
        }
      }
      if (this.currentPage === 1) {
        this.totalInstances = resp.data.count
      }
    },
    changePage() {
      this.loadInstance()
      scroll(0, 0)
    }
  },
  async mounted() {
    this.loadInstance()
  }
}
</script>

<style>
</style>
